import { color, font } from '../theme/tokens.js';
import { Icon } from './Icon.jsx';

/**
 * Compact rating: a filled brand star followed by the numeric score.
 *
 * @param {object} props
 * @param {number} props.value
 * @param {number} [props.size]
 */
export function Rating({ value, size = 11 }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
      <Icon name="star" size={size} stroke={color.primary} fill={color.primary} strokeWidth={0} />
      <span style={{ fontSize: size + 1, fontWeight: font.weight.semibold, color: color.ink }}>
        {value.toFixed(1)}
      </span>
    </span>
  );
}

/**
 * Five-star row, used where a review's score needs to read at a glance.
 *
 * @param {object} props
 * @param {number} props.value
 * @param {number} [props.size]
 */
export function StarRow({ value, size = 11 }) {
  const rounded = Math.round(value);
  return (
    <span style={{ fontSize: size, letterSpacing: 1 }} aria-label={`${value} out of 5`}>
      {[1, 2, 3, 4, 5].map((position) => (
        <span key={position} style={{ color: position <= rounded ? color.star : color.border }}>
          ★
        </span>
      ))}
    </span>
  );
}
